module.exports = __webpack_public_path__ + "img/paint-strip-neutral-left.99a0a35.png";